import { Redirect, Switch } from 'react-router-dom'
import List from 'app-support/warranty/views/List'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_WARRANTY } from 'app-support/permissions/Permissions'
import { warrantyRoute, warrantyRouteEdit } from 'routes/routeNames'
import EditProductWarrantyClaimDefaultContainer from 'app-support/warranty/views/Edit'
import { useHasWarrantyPermission } from 'app-support/warranty/hooks/use-Has-Warranty-Permission'

const ModulesRoutes: React.FC = () => {
  const { hasPermission } = useHasWarrantyPermission()

  if (!hasPermission) {
    return <Redirect to='/404' />
  }

  return (
    <Switch>
      <PermissionRoute
        permission={PERMISSION_MANAGE_WARRANTY}
        path={warrantyRouteEdit}
        component={EditProductWarrantyClaimDefaultContainer}
      />
      <PermissionRoute permission={PERMISSION_MANAGE_WARRANTY} path={warrantyRoute} component={List} />
    </Switch>
  )
}

export default withRegionSwitchHandler('/warranty')(ModulesRoutes)
